export const section = "section"
export const text = "text"
export const input = "input"
export const link = "link"
export const image = "image"
export const submit = "submit"
export const cancel = "cancel"